<template>
  <div class="plus-address-dialog">
    <div class="plus-address--wrapper">
      <span class="close" @click="handleClick"></span>
      <div class="dialog-title">修改收货地址</div>
      <div class="body">
        <div style="display:flex;">
          <div class="input-wrapper name">
            <div class="label">姓名</div>
            <input type="text" v-model="edit.receiveName" placeholder="收货人姓名" class="input" />
          </div>
          <div class="input-wrapper" style="width:260px">
            <div class="label">手机号</div>
            <input type="text" v-model="edit.receivePhone" placeholder="手机号码" class="input" />
          </div>
        </div>
        <div class="input-wrapper" style="width:100%;border:none;box-sizing: border-box">
          <!-- <input type="text" placeholder="选择省份/自治区" class="input" /> -->
          <el-select style="width:130px;" v-model="edit.receiveProvince" @change="provinceChange" placeholder="请选择省">
            <el-option
                v-for="item in regions"
                :title="item.divisionName"
                :key="item.id"
                :label="item.divisionName"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select style="width:130px;margin:0 5px;" v-model="edit.receiveCity" @change="receiveCityChange" placeholder="请选择市">
            <el-option
                v-for="item in receiveCitys"
                :title="item.divisionName"
                :key="item.id"
                :label="item.divisionName"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select style="width:130px;margin-right:5px;" v-model="edit.receiveArea" @change="receiveAreaChange" placeholder="请选择区">
            <el-option
                v-for="item in receiveAreas"
                :title="item.divisionName"
                :key="item.id"
                :label="item.divisionName"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select style="width:130px;" v-model="edit.receiveVillage"  placeholder="请选择城镇">
            <el-option
                v-for="item in receiveVillages"
                :title="item.divisionName"
                :key="item.id"
                :label="item.divisionName"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="input-wrapper" style="width:100%;box-sizing: border-box">
          <div class="label">详细地址</div>
          <textarea placeholder="完善详细地址" v-model="edit.detailAdd" class="textarea"></textarea>
        </div>
      </div>
      <div class="footer">
        <a href="javascript:;" class="btn default" @click="handleClick">取消</a>
        <a href="javascript:;" class="btn danger" @click="saveEvent">确定</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "../../../utils/auth";
import cityOption from '../../../utils/region';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      cityOption,
      receiveVillages: [],
      receiveAreas: [],
      receiveProvinces: [],
      receiveCitys: [],
      edit: {
        region: [],
        detailAdd: "",
        postCode: "",
        isDefault: false,
        receiveName: "",
        receivePhone: "",
        receiveProvince: "",
        receiveCity: "",
        receiveArea: "",
        receiveVillage: '',
      },
      optionProps: {
        value: 'id',
        label: 'divisionName',
        children: 'children',
        expandTrigger: 'hover'
      }
    };
  },
  props: {
    item: {
      type: Object
    }
  },
  watch: {
    regionMap(){
      if(this.regionMap[this.item.receiveProvince]){
        this.receiveCitys = this.regionMap[this.item.receiveProvince].children;
        this.receiveAreas = this.regionMap[this.item.receiveCity].children;
        this.getTownsList(this.item.receiveArea);
      }
    }
  },
  computed: {
    ...mapGetters(['regions','regionMap'])
  },
  created() {
    this.edit = JSON.parse(JSON.stringify(this.item));
    if(this.regionMap[this.item.receiveProvince]){
      this.receiveCitys = this.regionMap[this.item.receiveProvince].children;
      this.receiveAreas = this.regionMap[this.item.receiveCity].children;
      this.getTownsList(this.item.receiveArea);
    }
  },
  methods: {
    // 省份切换
    provinceChange(val){
      this.edit.receiveCity = '';
      if(this.regionMap[val]){
        this.receiveCitys = this.regionMap[val].children;
      }else{
        this.receiveCitys = [];
      }
      this.edit.receiveArea = '';
      this.receiveAreas = [];
      this.edit.receiveVillage = '';
      this.receiveVillages = [];
    },
    // 市切换
    receiveCityChange(val){
      this.edit.receiveArea = '';
      if(this.regionMap[val]){
        this.receiveAreas = this.regionMap[val].children;
      }else{
        this.receiveAreas = [];
      }
      this.edit.receiveVillage = '';
      this.receiveVillages = [];
    },
    // 区切换
    receiveAreaChange(val){
      this.edit.receiveVillage = '';
      this.receiveVillages = [];
      this.getTownsList(val);
    },
    // 获取城镇
    async getTownsList(areaId){
      let res = await this.$get('/api/getTownsList',{
        areaId
      });
      if(res.code==='200'){
        this.receiveVillages = res.townsList
      }else{
        this.receiveVillages = [];
      }
    },
    handleChange(value){
      this.region = value;
    },
    handleClick() {
      this.$emit("close");
    },
    async getAddressInfo(id) {
      let res = await this.$get("/api/getAddressInfo", {
        id
      });
      if (res.code === "200") {
        let data = res.addressInfo;
        this.edit = data
      }
    },
    async saveEvent() {
      let detailAdd = this.edit.detailAdd;
      let postCode = this.edit.postCode;
      let isDefault = this.edit.isDefault;
      let receiveName = this.edit.receiveName;
      let receivePhone = this.edit.receivePhone;
      if (!this.edit.receiveName) {
        this.$message.warning("请输入收货人姓名");
        return;
      }
      if (!this.edit.receivePhone) {
        this.$message.warning("请输入手机号码");
        return;
      }

      if (this.edit.receivePhone.length!==11) {
        this.$message.warning("手机号码格式不正确");
        return;
      }

      if (this.edit.receiveArea=='') {
        this.$message.warning("请选择所在省份、城市、区县");
        return;
      }

      if (!this.edit.detailAdd) {
        this.$message("请输入详细地址");
        return;
      }
      let token = getToken();
      let res = await this.$post("/api/insertMemberAddress", {
        id: this.edit.id,
        token,
        detailAdd,
        postCode,
        isDefault,
        receiveName,
        receivePhone,
        receiveProvince:this.edit.receiveProvince,
        receiveCity:this.edit.receiveCity,
        receiveArea:this.edit.receiveArea,
        receiveVillage: this.edit.receiveVillage
      });
      if (res.code === "200") {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.$emit("close",true);
    }
  }
};
</script>

<style lang="scss">
  .plus-address-dialog {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 90;
    background: rgba(0, 0, 0, 0.34);
    .plus-address--wrapper {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 0 35px 35px;
      width: 605px!important;
      height: 396px;
      background: #fff;
      border-radius: 3px;
      box-sizing: border-box;
      .dialog-title {
        font-family: 微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
        font-weight: 700;
        font-size: 20px;
        text-align: center;
        height: 50px;
        line-height: 50px;
      }
      .close {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
        width: 13px;
        height: 13px;
        background: url(../images/u977.png);
        &:hover {
          background: url(../images/u978.png);
        }
      }
      .body {
        padding-top: 20px;
        .input-wrapper {
          margin-bottom: 20px;
          width: 248px;
          position: relative;
          border: 1px #DCDFE6 solid;
          &.name {
            margin-right: 29px;
          }
          .label {
            position: absolute;
            left: 10px;
            top: -13px;
            font-size: 12px;
            text-indent: 10px;
            color: #999999;
            line-height: 20px;
            min-width: 50px;
            padding-right: 5px;
            background: #fff;
          }
          .input {
            padding: 0 20px;
            width: 208px;
            height: 38px;
            border: none;
          }
          .textarea {
            padding: 10px 20px;
            height: 78px;
            border: none;
            width: 100%;
            resize: none;
            box-sizing: border-box;
            font-family: 微软雅黑;
          }
        }
      }
      textarea:focus,
      input:focus {
        outline: none;
      }
      textarea::placeholder,
      input::placeholder {
        color: #cccccc;
      }
    }
    .footer {
      padding: 20px 0 20px;
      display: flex;
      justify-content: center;
      .btn {
        margin: 0 6px;
        display: block;
        width: 150px;
        height: 45px;
        color: #ffffff;
        background-color: rgba(26, 188, 156, 1);
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        &:hover {
          opacity: 0.9;
        }
      }
      .default {
        background: #f5f5f5;
        border: 1px #e4e4e4 solid;
        color: #999999;
        &:hover {
          color: #333333;
        }
      }
      .danger {
        background: #f04844;
        border: 1px #f04844 solid;
        color: #fff;
        &:hover {
          color: #fff;
        }
      }
    }
  }
</style>
